import React from "react";

function Footer() {
  return (
    <div className="footer">
      <div className="footerMenu">
        <div className="footerGauche">
          <a href="/">Accueil</a>
          <a href="/Pages/NousJoindre">Nous joindre</a>
          <a href="/Pages/Compte">Votre Compte</a>
        </div>
        <div className="footerCentre">
          <a href="/Pages/Alfa">Alfa</a>
          <a href="/Pages/Bravo">Bravo</a>
          <a href="/Pages/Charlie">Charlie</a>
          <a href="/Pages/Delta">Delta</a>
          <a href="/Pages/Echo">Echo</a>
        </div>
        <div className="footerDroit">
          Logoipsum
          <br />
          <br />
          128 North Van Buren Circle
          <br />
          Oceanside, Montana 37551
          <br />
          (602) 908-0172
        </div>
      </div>
      <div className="copyright">
        Copyright © 2018 - 2021 Logoipsum tous droits réservés
      </div>
    </div>
  );
}

export default Footer;
